import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { SearchOutlined } from "@mui/icons-material";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { uniqBy } from "lodash";
import { DownOutlined, EditOutlined, FilterOutlined, ExclamationCircleFilled, CalendarOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Form,
  Select,
  Button,
  Checkbox,
  DatePicker,
  Dropdown,
  Input,
  Modal,
  Table,
  message,
  Popconfirm,
  Spin,
  Popover,
} from "antd";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { ReactComponent as Trash } from "../../assets/icons/Deleted_Trash.svg";
import PerformanceContract from "./PerformanceContract";
import { useHistory } from "react-router-dom";
import { CALL_API } from "common/API";
import { getLatestReviewedAt, isReEnabledAfterCycleClosed } from "./cycleRules";
import {
  getLoadNewDataList,
  getLocations,
  getSupervisorList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import moment from "moment";
import trashfull from "../../assets/Trash_Full.png";
import { connect, useDispatch, useSelector } from "react-redux";
import { dateInDetail } from "utils/Date";
import { STATUS_CODE } from "common/Constants";
import { setLoadNewDataList, setMyTeamPerformanceList } from "redux/actions";
import { ButtonFilled } from "reusableComponent/UIButtons";
import CreateEditPerformance from "./CreateEditPerformance";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isBetween from "dayjs/plugin/isBetween";
import { ReactComponent as ChartBarIcon } from "../../../src/assets/icons/chart-bar-vertical-01-svgrepo-com 1 (4).svg";
import { ReactComponent as ChartBarIcon2 } from "../../../src/assets/icons/chart-bar-vertical-01-svgrepo-com 1 (2).svg";
import { ReactComponent as FolderIcon } from "../../assets/icons/FolderIcon.svg";
import PerformanceMatrix from "./Viewperformance/PerformanceMatrix";
import { bindActionCreators } from "redux";
import Consolidated from "./Consolidated";

dayjs.extend(isBetween);
dayjs.extend(advancedFormat);

// Financial year runs April -> March, so a date in Jan-Mar belongs to the FY
// that started the previous calendar year. Change this one constant to move
// the boundary (7 = July, 10 = October).
const FY_START_MONTH = 4;

// "2025/2026" for any date inside that financial year.
const getFinancialYear = (date) => {
  const d = dayjs(date);
  if (!date || !d.isValid()) return null;
  const startYear = d.month() + 1 >= FY_START_MONTH ? d.year() : d.year() - 1;
  return `${startYear}/${startYear + 1}`;
};

// Inclusive date range covered by a "2025/2026" label.
const getFinancialYearRange = (label) => {
  const startYear = Number(String(label).split("/")[0]);
  const start = dayjs(`${startYear}-${String(FY_START_MONTH).padStart(2, "0")}-01`).startOf("day");
  return { start, end: start.add(1, "year").subtract(1, "day").endOf("day") };
};

const { RangePicker } = DatePicker;
const StyledRangePicker = styled(RangePicker)`
  width: 240px !important;
  border-radius: 24px !important;
  margin-left: 10px;
`;
const Styleddiv = styled.div`
  .search-type-date {
    display: flex;
    gap: 24px;
    width: 100%;
  }
  /* display:flex above makes .ant-form-item-row the flex item, and it sizes to
     its content — so a width:100% on the Select below resolves against a
     collapsed ancestor. Stretch the whole chain so Date fills its column like
     the other filters do. */
  .search-type-date .ant-form-item-row,
  .search-type-date .ant-form-item-control,
  .search-type-date .ant-form-item-control-input,
  .search-type-date .ant-form-item-control-input-content {
    width: 100%;
    flex: 1 1 auto;
  }
  .searchbar {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .type-dropdown {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .date-picker {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .ant-picker-input {
    display: flex;
    align-items: center;
  }

  .ant-picker-suffix {
    order: -1; /* This moves the icon to the front */
    margin-right: 8px; /* Optional: adjust the space between the icon and the placeholder */
  }
  .ant-table-thead > tr > th {
    font-weight: 500;
    font-size: 16px;
  }
  .ant-table-tbody > tr > td {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }

  .normal-column {
    min-width: 300px;
    white-space: normal;
  }

  .action-icons {
    display: none;
    position: absolute;
  }

  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 12px;
    cursor: pointer;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #52c41a !important; /* Green */
    border-color: #52c41a !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #52c41a !important;
  }

  .ant-checkbox-checked::after {
    border: none !important;
  }

  .ant-checkbox-inner {
    width: 16px;
    height: 16px;
  }
  .hovered-row {
    width: 100px;
    display: flex;
    gap: 1rem;
    opacity: 1;
  }
  .row-table {
    width: 100px;
    opacity: 0;
  }

  .table_action_icon {
    background-color: #deefee;
    color: black;
    cursor: pointer;
  }
  .custom-row {
    height: 50px; /* Adjust row height */
  }

  .custom-row td {
    padding: 10px; /* Adjust cell padding */
  }
  .custom-select .ant-select-selection-placeholder {
    color: black !important;
  }

  /* Fill the column like the other filters — a fixed width left a gap between
     Date and the next filter. The width has to go on the Select root; the
     inner selector alone collapses to content width. */
  .custom-select {
    width: 100% !important;
  }

  .custom-select .ant-select-selector {
    border-radius: 24px !important;
    color: black !important;
    width: 100% !important;
  }
`;
const StyledModal = styled(Modal)`
  .delete-modal-text {
    font-weight: 400;
    font-size: 18px;
    color: #636980;
  }
  .two-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 16px;
  }

  .no-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    color: #1f243b;
    font-weight: 400;
    font-size: 16px;
  }
  .yes-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background: #deefee;
    border: 1px solid #deefee;
    font-weight: 400;
    font-size: 16px;
  }
  .tick-deleted {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .deleted-text {
    font-weight: 400;
    font-size: 18px;
  }
`;

const CustomModalContent = styled.div`
  content-align: center;
  height: 50px;
  border-radius: 8px !important;
  background-color: white;
  text-align: center;
`;

const MyTeamPerformance = ({
  editPerformanceData,
  userInfo,
  setIsAddEdit,
  isAddEdit,
  setSelectedUserRecord,
  selectedItem,
  setBreadCrum,
  setLoadNewData,
  loadNewDataList,
}) => {
  const [filteredData, setFilteredData] = useState([]);
  const [performanceContractList, setPerformanceContractList] = useState([]);
  const [form] = Form.useForm();
  const [hoveredRow, setHoveredRow] = useState();
  const history = useHistory();
  const userDataList = useSelector((state) => getUserList(state)) || [];
  const [loading, setLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [isDeleteModalLoading, setIsDeleteModalLoading] = useState(false);
  const [chartModalOpen, setChartModalOpen] = useState(false);
  const [chartData, setChartData] = useState({});
  const [chartLoading, setChartLoading] = useState(false);
  const [newDataLoading, setNewDataLoading] = useState(false);
  const [isConsolidate, setIsConsolidate] = useState(false);
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [isBlockedModalOpen, setIsBlockedModalOpen] = useState(false);
  const [loadListSummary, setLoadListSummary] = useState({ generated: 0, notGenerated: 0 });
  const [isAdjustDateModalOpen, setIsAdjustDateModalOpen] = useState(false);
  const [adjustDateRecord, setAdjustDateRecord] = useState(null);
  const [adjustStartDate, setAdjustStartDate] = useState(null);
  const [adjustEndDate, setAdjustEndDate] = useState(null);
  const [isAdjustDateLoading, setIsAdjustDateLoading] = useState(false);

  const getPerformanceContractData = async () => {
    setLoading(true);
    const { code, performanceContractList } = await CALL_API(
      `appraisal/appraisermyteam?createdby=${userInfo?.userid}`,
      "get"
    );
    if (code === STATUS_CODE?.SUCCESS) {
      setPerformanceContractList(performanceContractList);
      setLoading(false);
    }
  };

  const transformRollover = (data) => {
    return data?.map((item, index) => {
      return {
        ...item,
        previousappraisalperiod: item?.targetobjectives,
        expectedoutcome: item?.expectedoutcomes,
        TargetDate: dayjs(item?.targetdate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        Weightage: item?.weightage,
      };
    });
  };

  useEffect(() => {
    getPerformanceContractData();
  }, []);

  useEffect(() => {
    const unlisten = history.listen(() => {
      getPerformanceContractData();
    });
    return unlisten;
  }, [history]);

  useEffect(() => {
    try {
      const saved = localStorage.getItem("loadNewDataList");
      if (saved) {
        const parsed = JSON.parse(saved);

        if (Array.isArray(parsed) && parsed.length > 0) {
          setLoadNewData(parsed);
        }
      }
    } catch (e) {
      console.error("localStorage load error", e);
    }
  }, []);

  const finduser = userDataList?.find(
    (item) => item?.userid === userInfo?.userid
  );

  const findData = useMemo(() => {
    if (!userDataList) return [];

    const reduceList = userDataList.reduce((acc, item) => {
      const filteredAppraisals = item.appraisalInformation?.filter(
        (data) =>
          data?.appraiser === finduser?.userid &&
          data?.appraisal === "Yes" &&
          item?.statusid === "1"
      );

      const matchedContract = performanceContractList?.filter(
        (val) =>
          val?.apraiseemailid === item?.userid &&
          filteredAppraisals?.some((a) => a.roletype === val?.roletype) &&
          (item?.performanceid !== "" || item?.performanceid !== null)
      );

      const reviewedByMe = performanceContractList?.filter(
        (val) =>
          val?.apraiseemailid === item?.userid &&
          val?.contractstatus === "reviewed" &&
          val?.apraisercreatedby === userInfo?.userid &&
          !matchedContract?.some((m) => m.contractid === val.contractid)
      );

      const hasValidAppraisals =
        filteredAppraisals && filteredAppraisals.length > 0;

      if (matchedContract?.length) {
        matchedContract?.map((match) =>
          acc.push({
            ...item,
            attendedon: match?.attendedon || "",
            averagesoftscore: match?.averagesoftscore || "",
            averagetechnicalscore: match?.averagetechnicalscore || "",
            dateofbirth: dayjs(item?.dateofbirth).format("DD-MM-YYYY"),
            appraisalInformation: filteredAppraisals,
            rolloverresponsibility: match?.rolloverresponsibility || [],
            softskills: match?.softskills || [],
            startegicobjectives: match?.startegicobjectives || [],
            upcomingappraisalperiod: match?.upcomingappraisalperiod || [],
            period: match?.period || "",
            createdat: match?.createdat || "",
            updatedat: match?.updatedat || "",
            contractstatus: match?.contractstatus || "",
            attendstartdate: match?.attendstartdate
              ? dayjs(match?.attendstartdate)
              : "",
            attendenddate: match?.attendenddate
              ? dayjs(match?.attendenddate)
              : "",
            apraisercreatedat: match?.apraisercreatedat || "",
            apraisercreatedby: match?.apraisercreatedby || "",
            apraiserupdatedat: match?.apraiserupdatedat || "",
            apraiserupdatedby: match?.apraiserupdatedby || "",
            accepteddeclinedon: match?.accepteddeclinedon || "",
            contractid: match?.contractid,
            performanceid: match?.performanceid || 0,
            existingrollover: transformRollover(match?.existingrollover) || [],
            roletype: match?.roletype || "",
          })
        );
      } else if (hasValidAppraisals) {
        acc.push({
          ...item,
          dateofbirth: dayjs(item?.dateofbirth).format("DD-MM-YYYY"),
          appraisalInformation: filteredAppraisals,
          rolloverresponsibility: matchedContract?.rolloverresponsibility || [],
          softskills: matchedContract?.softskills || [],
          startegicobjectives: matchedContract?.startegicobjectives || [],
          upcomingappraisalperiod:
            matchedContract?.upcomingappraisalperiod || [],
          period: matchedContract?.period || "",
          createdat: matchedContract?.createdat || "",
          updatedat: matchedContract?.updatedat || "",
          contractstatus: matchedContract?.contractstatus || "",
          attendstartdate: matchedContract?.attendstartdate
            ? dayjs(matchedContract?.attendstartdate)
            : "",
          attendenddate: matchedContract?.attendenddate
            ? dayjs(matchedContract?.attendenddate)
            : "",
          apraisercreatedat: matchedContract?.apraisercreatedat || "",
          apraisercreatedby: matchedContract?.apraisercreatedby || "",
          apraiserupdatedat: matchedContract?.apraiserupdatedat || "",
          apraiserupdatedby: matchedContract?.apraiserupdatedby || "",
          accepteddeclinedon: matchedContract?.accepteddeclinedon || "",
          contractid: matchedContract?.contractid,
          performanceid: matchedContract?.performanceid || 0,
          averagesoftscore: "",
          averagetechnicalscore: "",
          attendedon: "",
          existingrollover: [],
          roletype: matchedContract?.roletype || "",
        });
      }

      if (reviewedByMe?.length) {
        reviewedByMe.forEach((match) =>
          acc.push({
            ...item,
            attendedon: match?.attendedon || "",
            averagesoftscore: match?.averagesoftscore || "",
            averagetechnicalscore: match?.averagetechnicalscore || "",
            dateofbirth: dayjs(item?.dateofbirth).format("DD-MM-YYYY"),
            appraisalInformation: filteredAppraisals?.length
              ? filteredAppraisals
              : item?.appraisalInformation,
            rolloverresponsibility: match?.rolloverresponsibility || [],
            softskills: match?.softskills || [],
            startegicobjectives: match?.startegicobjectives || [],
            upcomingappraisalperiod: match?.upcomingappraisalperiod || [],
            period: match?.period || "",
            createdat: match?.createdat || "",
            updatedat: match?.updatedat || "",
            contractstatus: match?.contractstatus || "",
            attendstartdate: match?.attendstartdate ? dayjs(match?.attendstartdate) : "",
            attendenddate: match?.attendenddate ? dayjs(match?.attendenddate) : "",
            apraisercreatedat: match?.apraisercreatedat || "",
            apraisercreatedby: match?.apraisercreatedby || "",
            apraiserupdatedat: match?.apraiserupdatedat || "",
            apraiserupdatedby: match?.apraiserupdatedby || "",
            accepteddeclinedon: match?.accepteddeclinedon || "",
            contractid: match?.contractid,
            performanceid: match?.performanceid || 0,
            existingrollover: transformRollover(match?.existingrollover) || [],
            roletype: match?.roletype || "",
          })
        );
      }

      return acc;
    }, []);
    const safeLoadNewData = Array.isArray(loadNewDataList) ? loadNewDataList : [];

    const stubUserIds = new Set(safeLoadNewData.map((s) => s.userid));
    const deduplicatedReduceList = reduceList.filter(
      (r) => (r.contractid && r.contractid !== "") || !stubUserIds.has(r.userid)
    );

    return [...safeLoadNewData, ...deduplicatedReduceList];
  }, [
    userDataList,
    finduser?.userid,
    performanceContractList,
    loadNewDataList,
  ]);

  const getPendingRoles = (roleStatuses, configuredRoleTypes, globalMaxPid) =>
    configuredRoleTypes
      .filter((rt) => {
        const rs = roleStatuses[rt];
        if (!rs) return false;
        // The blockers: any role not yet reviewed — an open (unreviewed)
        // contract (current cycle or drift), or not yet created at all.
        // configuredRoleTypes here is already scoped to this cycle's cohort,
        // so a "not created" entry means genuinely pending, not a role
        // added after the cycle already closed.
        if (rs.status !== "reviewed") return true;
        // "reviewed" alone doesn't say WHICH cycle it closed. A role whose
        // latest contract is reviewed but sits at an older cycle than the one
        // the team is on has still not closed the current cycle, and is what
        // holds it open — report it instead of reading it as done.
        return (rs.maxPid || 0) < globalMaxPid;
      })
      .join(", ");

  const blockedColumns = [
    {
      title: "S.No",
      key: "sno",
      width: "10%",
      render: (_, __, index) => index + 1,
    },
    { title: "Name", dataIndex: ["user", "fullname"], key: "name", width: "30%" },
    {
      title: "Employee ID",
      dataIndex: ["user", "employeeid"],
      key: "employeeid",
      width: "25%",
    },
    {
      title: "Pending Role",
      key: "pendingRole",
      width: "35%",
      render: (_, record) =>
        getPendingRoles(
          record.roleStatuses,
          record.configuredRoleTypes,
          record.globalMaxPid
        ),
    },
  ];

  const getLoadNewList = async () => {
    setNewDataLoading(true);
    try {
      const [contractRes, pidRes] = await Promise.all([
        CALL_API(`appraisal/appraisermyteam?createdby=${userInfo?.userid}`, "get"),
        CALL_API("appraisal/performanceids", "get"),
      ]);

      if (contractRes.code !== STATUS_CODE?.SUCCESS) {
        message.error("Failed to fetch latest contracts.");
        setNewDataLoading(false);
        return;
      }

      const freshList = contractRes.performanceContractList;
      const performanceIdList = pidRes?.performanceIdList || [];

      // pidMap: { email: { roletype: maxPid } }
      // statusFromPid: { email: { roletype: contractstatus } }  — from DB, not George's view
      const pidMap = {};
      const statusFromPid = {};
      for (const row of performanceIdList) {
        if (!pidMap[row.apraiseemailid]) pidMap[row.apraiseemailid] = {};
        if (!statusFromPid[row.apraiseemailid]) statusFromPid[row.apraiseemailid] = {};
        pidMap[row.apraiseemailid][row.roletype] = Number(row.latest_performanceid || 0);
        statusFromPid[row.apraiseemailid][row.roletype] = row.contractstatus || "not_created";
      }

      const currentLoadList = Array.isArray(loadNewDataList) ? [...loadNewDataList] : [];
      const existingStubMap = new Map(
        currentLoadList.map((s) => [s.userid, Number(s.performanceid || 0)])
      );

      const contractsByUser = freshList.reduce((map, contract) => {
        if (!map.has(contract.apraiseemailid)) map.set(contract.apraiseemailid, []);
        map.get(contract.apraiseemailid).push(contract);
        return map;
      }, new Map());

      // Cohort/cycle-closed checks need EVERY appraiser's contracts for the
      // employee, not just ones this manager created — appraisermyteam is
      // scoped to createdby=me, so a manager who didn't create the current
      // cycle's contract would wrongly see anyClosedAtMax=false (as if the
      // cycle were still fully open) and every sibling role, including ones
      // they don't own, would get pulled into their blocked-list popup.
      const candidateUsers = userDataList.filter((user) => {
        const fa = user.appraisalInformation?.filter(
          (data) =>
            data?.appraiser === userInfo?.userid &&
            data?.appraisal === "Yes" &&
            user?.statusid === "1"
        );
        return fa && fa.length > 0;
      });

      const allContractsResults = await Promise.all(
        candidateUsers.map((user) =>
          CALL_API(`appraisal/appraiseemine?userid=${user.userid}`, "get")
        )
      );

      const newStubs = [];
      const blockedList = [];

      // Cohort math needs EVERY appraiser's contracts for an appraisee, not
      // only the ones this manager created. appraisermyteam is scoped to
      // createdby=me, so deriving the cycle from it alone makes the answer
      // VIEWER-DEPENDENT: the manager who created the reviewed Primary sees a
      // cycle that has started closing, while a manager who created only
      // Additional1 sees no reviewed contract at all — the same cycle reads as
      // "fully open" to one and "closing" to the other, and Primary shows up
      // as not_created in the popup of everyone who didn't create it.
      // Fan out one appraiseemine per candidate so both sides agree.
      const candidates = [];
      for (const user of userDataList) {
        const filteredAppraisals = user.appraisalInformation?.filter(
          (data) =>
            data?.appraiser === userInfo?.userid &&
            data?.appraisal === "Yes" &&
            user?.statusid === "1"
        );

        if (!filteredAppraisals || filteredAppraisals.length === 0) continue;

        // Gate A stays scoped to the manager's OWN contracts — unchanged.
        if ((contractsByUser.get(user.userid) || []).length === 0) continue;

        candidates.push({ user, filteredAppraisals });
      }

      const allContractsByUser = new Map();
      await Promise.all(
        candidates.map(async ({ user }) => {
          const res = await CALL_API(
            `appraisal/appraiseemine?userid=${user.userid}`,
            "get"
          );
          allContractsByUser.set(
            user.userid,
            res?.performanceContractList || []
          );
        })
      );

      for (const { user, filteredAppraisals } of candidates) {
        // Every appraiser's contracts for this appraisee (see fan-out above).
        const userContracts = allContractsByUser.get(user.userid) || [];

        const allContractsForUser = allContractsByUser.get(user.userid) || [];

        // All active roletypes for this appraisee (across all appraisers)
        const allConfiguredRoleTypes = (user.appraisalInformation || [])
          .filter((a) => a?.appraisal === "Yes")
          .map((a) => a?.roletype)
          .filter(Boolean);

        if (allConfiguredRoleTypes.length === 0) continue;

        const userPidMap = pidMap[user.userid] || {};

        // Build role status map
        const roleStatuses = {};
        for (const rt of allConfiguredRoleTypes) {
          const maxPid = userPidMap[rt] || 0;
          const status = maxPid > 0
            ? statusFromPid[user.userid]?.[rt] || "unknown"
            : "not_created";
          roleStatuses[rt] = { maxPid, status };
        }

        // Current (top) cycle any role has reached.
        const globalMaxPid = allConfiguredRoleTypes.reduce(
          (max, rt) => Math.max(max, userPidMap[rt] || 0), 0
        );

        // Cohort = who actually belongs to the CURRENT cycle. A configured
        // role is a cohort member only if it has a contract at the current
        // cycle, or it's listed in the current cycle's own roster snapshot
        // (appraisalinformation, frozen at contract creation). Contracts
        // left over from EARLIER cycles alone don't count — a role deleted
        // before the current cycle was created (absent from its snapshot)
        // and re-added after it closed is a fresh member joining at the
        // next cycle, not a lagging one, and must not block the team.
        const contractsAtMax = allContractsForUser.filter(
          c => Number(c.performanceid) === globalMaxPid
        );
        const snapshotRoleTypesAtMax = new Set();
        contractsAtMax.forEach(c => {
          (c?.appraisalinformation || [])
            .filter(r => r?.appraisal === "Yes")
            .forEach(r => {
              if (r?.roletype) {
                snapshotRoleTypesAtMax.add(r.roletype.trim().toLowerCase());
              }
            });
        });
        // The snapshot cutoff only applies once the cycle is FULLY closed
        // (every contract at max reviewed). While ANY contract in it is still
        // open the cycle is unfinished, so a role added now catches up into
        // this same cycle and must count as pending here even though it isn't
        // in the frozen snapshot. Gating on "some contract reviewed" instead
        // let a single early review lock the roster: Primary reviewing first
        // while Additional1 was still open pushed a newly added Additional2
        // to the next cycle and hid it from the pending popup.
        //
        // Not enough on its own: a sibling can race ahead a whole cycle while a
        // genuine cohort member lags behind (e.g. Additional1 reviewed at cycle
        // 2 while Primary still sat at cycle 1). Then the only contract at max
        // (Additional1) is reviewed, the set looks fully closed, and a newly
        // added role gets pushed to the next cycle — even though the cycle is
        // still open (Primary owes it). So the cycle is NOT closed while any
        // role that BELONGS to it lags below the max cycle.
        //
        // "Belongs to it" = present in the cycle's frozen snapshot. That guard
        // is what keeps the re-enable case intact: a role deleted then re-added
        // after the cycle closed also sits at an old low pid, but it is NOT in
        // this cycle's snapshot, so it must NOT hold the closed cycle open
        // (doing so would resurrect the ghost-tab bug cycleRules prevents).
        // Legacy rows with no snapshot fall back to counting any behind role.
        const hasSnapshotAtMax = snapshotRoleTypesAtMax.size > 0;

        const contractsAtMaxAllReviewed =
          contractsAtMax.length > 0 &&
          contractsAtMax.every(c => c?.contractstatus === "reviewed");

        // Roster history tells a genuine laggard from an after-close re-add.
        // Fetch it once (only when some role isn't at the max cycle) and reuse
        // it for the cutoff, the behind-role check, and the cohort filter.
        const rolesNotAtMax = allConfiguredRoleTypes.filter(
          rt => (userPidMap[rt] || 0) !== globalMaxPid
        );
        let rosterHistoryList = [];
        if (rolesNotAtMax.length > 0) {
          const historyRes = await CALL_API(
            `appraisal/appraisalhisorty?userid=${user.userid}`,
            "get"
          );
          rosterHistoryList = historyRes?.historyList || [];
        }
        const wasEverDeleted = rt =>
          rosterHistoryList.some(
            h =>
              (h?.roletype || "").trim().toLowerCase() ===
              (rt || "").trim().toLowerCase() && h?.change === "Row deleted"
          );

        // Provisional "cycle closed" cutoff, computed WITHOUT the re-enable
        // check so it can be used to evaluate that check (no circular
        // dependency). The cycle is only GENUINELY closed when no GENUINE
        // laggard is still holding it open. A genuine laggard is a cohort role
        // (present in this cycle's snapshot) that is behind the max cycle AND
        // was never deleted — it simply hasn't caught up yet. A behind role
        // that WAS deleted might instead be an after-close re-add; the cutoff
        // below classifies that. Snapshot membership alone can't decide this,
        // because a deleted role lingers in an OLDER contract's stale snapshot
        // (snapshots are re-fetched per contract at different times, §4) — only
        // the delete history separates a real laggard from a re-add.
        const behindCohortRoles = allConfiguredRoleTypes.filter(rt => {
          const pid = userPidMap[rt] || 0;
          if (!(pid > 0 && pid < globalMaxPid)) return false;
          return hasSnapshotAtMax
            ? snapshotRoleTypesAtMax.has((rt || "").trim().toLowerCase())
            : true;
        });
        const genuineLaggardExists = behindCohortRoles.some(
          rt => !wasEverDeleted(rt)
        );
        const provisionalCutoff =
          contractsAtMaxAllReviewed && !genuineLaggardExists
            ? getLatestReviewedAt(contractsAtMax)
            : 0;

        const isReEnabledAfterClose = rt =>
          provisionalCutoff > 0 &&
          isReEnabledAfterCycleClosed(rosterHistoryList, rt, provisionalCutoff);

        // A role keeps the cycle OPEN only if it genuinely belongs to it and is
        // merely behind (in the snapshot, below the max cycle) AND was NOT
        // re-added after the cycle closed.
        const anyCohortRoleBehindMax = behindCohortRoles.some(
          rt => !isReEnabledAfterClose(rt)
        );
        const cycleFullyReviewedAtMax =
          contractsAtMaxAllReviewed && !anyCohortRoleBehindMax;
        // Legacy contracts created before the snapshot column was populated
        // have an empty appraisalinformation — fall back to the old rule
        // there (any role with any contract counts), so genuinely-lagging
        // roles on old data still block correctly. (hasSnapshotAtMax computed
        // above, shared with the behind-role check.)
        const snapshotCohortRoleTypes = allConfiguredRoleTypes.filter(rt => {
          const pid = userPidMap[rt] || 0;
          if (pid === globalMaxPid) return true;   // present at current cycle
          if (!cycleFullyReviewedAtMax) return true; // cycle still open — role joins it
          return hasSnapshotAtMax
            ? snapshotRoleTypesAtMax.has((rt || "").trim().toLowerCase())
            : pid > 0;
        });

        // The snapshot on a reviewed contract is re-fetched LIVE at review time
        // (updateReviewContractSatatus), not frozen at creation — so a role
        // removed from the roster moments AFTER the cycle's last review stays
        // baked into that snapshot. Re-added later, it looks like a cohort
        // member that never got a contract, and holds the closed cycle open
        // forever. getNextPerformanceId already treats a role re-added after
        // the cycle closed as a fresh joiner for the next cycle; the cohort
        // rule here has to agree, or Load New List blocks a cycle the writer
        // considers finished. Reuses the history + cutoff computed above.
        const reEnabledRoleTypes = new Set();
        snapshotCohortRoleTypes
          .filter(rt => (userPidMap[rt] || 0) !== globalMaxPid)
          .forEach(rt => {
            if (isReEnabledAfterClose(rt)) reEnabledRoleTypes.add(rt);
          });
        const cohortRoleTypes = snapshotCohortRoleTypes.filter(
          rt => !reEnabledRoleTypes.has(rt)
        );

        // Are all configured roles PRESENT at the current cycle (each has a
        // contract for globalMaxPid)? If so, clicking Load New List means
        // "open the next cycle" — which requires the current cycle fully closed.
        // If some role hasn't reached the current cycle yet (behind or never
        // created), we're still filling the current cycle → catch-up, no popup.
        const allPresentAtCurrent = cohortRoleTypes.every(
          rt => (userPidMap[rt] || 0) === globalMaxPid
        );

        // HARD STOP only for an appraisal that is genuinely OPEN — a contract
        // exists and hasn't been reviewed:
        //  - Advance-blocked (spec): every role is at the current cycle but one
        //    isn't reviewed → the previous cycle isn't fully closed.
        //  - Drift: a role is open on a cycle BELOW the current one — that
        //    contract must be finished before the role moves on.
        //
        // A cohort role that was never created is NOT an open contract, it's a
        // missing one, and it must not hard-stop the whole employee: doing that
        // also denies a stub to every OTHER manager whose own role is merely
        // behind and safe to catch up (and to the missing role's own owner,
        // who is the one person able to fix it). It can't cause a premature
        // advance either — a role short of globalMaxPid forces
        // allPresentAtCurrent false, so targetPid stays on the current cycle.
        // It still gets reported: managers with nothing to create fall through
        // to the behindAppraisals popup below, which lists it as not_created.
        const hasOpenContract = allConfiguredRoleTypes.some(rt => {
          const maxPid = userPidMap[rt] || 0;
          if (maxPid === 0) return false;                 // never created — missing, not open
          const status = statusFromPid[user.userid]?.[rt] || "unknown";
          if (status === "reviewed") return false;        // closed — not a blocker
          return maxPid < globalMaxPid || allPresentAtCurrent; // drift, or advance-blocked
        });



        if (hasOpenContract) {
          blockedList.push({ user, roleStatuses, configuredRoleTypes: cohortRoleTypes, globalMaxPid });
          continue;
        }

        // Not blocked → advance to the next cycle only when every COHORT role
        // is present at the current cycle AND all closed; otherwise stay at
        // the current cycle so behind / never-created cohort roles catch up.
        // Non-cohort roles (re-added after the cycle closed) don't pin the
        // target — their own creation jumps to the next cycle anyway
        // (getNextPerformanceId re-add rule).
        const existingRoleTypes = cohortRoleTypes.filter(rt => (userPidMap[rt] || 0) > 0);
        const allAtMaxPid = existingRoleTypes.length > 0 && existingRoleTypes.every(
          rt => (userPidMap[rt] || 0) === globalMaxPid
        );
        const targetPid = (allAtMaxPid && allPresentAtCurrent) ? globalMaxPid + 1 : globalMaxPid;
        const stubPid = targetPid - 1; // CreateEditPerformance adds +1 on creation

        // Per-role guard: only offer the roles THIS manager owns that are
        // actually behind the target cycle. A role already at the target cycle
        // must not be offered again — creating it would make a duplicate.
        const behindAppraisals = (filteredAppraisals || []).filter(
          (a) => (userPidMap[a?.roletype] || 0) < targetPid
        );
        if (behindAppraisals.length === 0) {
          // Nothing to generate for THIS manager. If the current cycle
          // itself isn't fully closed, tell the manager WHY instead of
          // silently skipping — list every cohort role not yet reviewed
          // at the current cycle (contract still open, or not created
          // there yet).
          const roleStatusesAtMax = {};
          let anyPendingAtMax = false;
          for (const rt of cohortRoleTypes) {
            const contractAtMax = contractsAtMax.find(
              (c) => c.roletype === rt
            );
            const status = contractAtMax
              ? contractAtMax.contractstatus
              : "not_created";
            roleStatusesAtMax[rt] = {
              maxPid: contractAtMax ? globalMaxPid : 0,
              status,
            };
            if (status !== "reviewed") anyPendingAtMax = true;
          }
          if (anyPendingAtMax) {
            blockedList.push({
              user,
              roleStatuses: roleStatusesAtMax,
              configuredRoleTypes: cohortRoleTypes,
              globalMaxPid,
            });
          }
          continue;
        }

        const existingPid = existingStubMap.get(user.userid);
        if (existingPid !== undefined && existingPid === stubPid) continue;

        const latestPerformanceid = stubPid;
        const latestCycleContracts = allContractsForUser.filter(
          (c) => Number(c.performanceid) === globalMaxPid
        );

        const primaryContract =
          latestCycleContracts.find((c) => c.roletype === "Primary") ||
          latestCycleContracts[0];

        const idx = currentLoadList.findIndex((s) => s.userid === user.userid);
        if (idx !== -1) currentLoadList.splice(idx, 1);

        newStubs.push({
          ...user,
          dateofbirth: dayjs(user?.dateofbirth).format("DD-MM-YYYY"),
          appraisalInformation: behindAppraisals,
          existingrollover: transformRollover(primaryContract?.existingrollover) || [],
          rolloverresponsibility: primaryContract?.existingrollover
            ? transformRollover(primaryContract.existingrollover)
            : [],
          performanceid: latestPerformanceid,
          contractid: "",
          contractstatus: "",
          softskills: [],
          startegicobjectives: [],
          upcomingappraisalperiod: [],
          period: "",
          createdat: "",
          updatedat: "",
          attendstartdate: "",
          attendenddate: "",
          apraisercreatedat: "",
          apraisercreatedby: "",
          apraiserupdatedat: "",
          apraiserupdatedby: "",
          accepteddeclinedon: "",
          averagesoftscore: "",
          averagetechnicalscore: "",
          attendedon: "",
        });
      }

      setLoadListSummary({
        generated: newStubs.length,
        notGenerated: blockedList.length,
      });

      if (blockedList.length > 0) {
        setBlockedUsers(blockedList);
        setIsBlockedModalOpen(true);
      }

      if (newStubs.length > 0) {
        const merged = [...newStubs, ...currentLoadList];
        setLoadNewData(merged);
        message.success(`${newStubs.length} new contract row(s) loaded.`);
      } else if (blockedList.length === 0) {
        message.info("No new contracts to load.");
      }
    } catch (err) {
      console.error("getLoadNewList error", err);
      message.error("Something went wrong.");
    } finally {
      setNewDataLoading(false);
    }
  };

  const filterPerformanceData = useMemo(() => {
    return findData?.filter((item) => {
      const start = dayjs(item?.attendstartdate, "YYYY-MM-DD").startOf("day");
      const end = dayjs(item?.attendenddate, "YYYY-MM-DD").endOf("day");
      const today = dayjs().startOf("day");

      return (
        item?.contractstatus !== "created" &&
        item?.contractstatus !== "resend" &&
        item?.contractstatus !== "updated" &&
        item?.contractstatus !== "declined" &&
        (item?.contractstatus === "accepted" ||
          item?.contractstatus === "attended" ||
          item?.contractstatus === "draft" ||
          item?.contractstatus === "reviewed")
      );
    });
  }, [findData]);

  const [consolidatedContractData, setConsolidatedContractData] = useState([]);

  useEffect(() => {
    const teamMemberIds = Array.from(
      new Set(findData.map((d) => d.userid).filter(Boolean))
    );
    if (teamMemberIds.length === 0) {
      setConsolidatedContractData([]);
      return;
    }

    let cancelled = false;
    (async () => {
      // appraisermyteam is scoped to contracts THIS supervisor created, so it only
      // ever has one role (e.g. Primary) per employee. Consolidated needs every
      // role regardless of who appraised it, so fetch each employee's full record.
      const results = await Promise.all(
        teamMemberIds.map((userid) =>
          CALL_API(`appraisal/appraiseemine?userid=${userid}`, "get")
        )
      );
      if (cancelled) return;

      const merged = results
        .flatMap((res) => res?.performanceContractList || [])
        .filter(
          (c) =>
            c.contractstatus === "reviewed" || c.contractstatus === "draft"
        )
        .map((c) => {
          const user = (userDataList || []).find(
            (u) => u.userid === c.apraiseemailid
          );
          return {
            ...c,
            userid: c.apraiseemailid,
            fullname: user?.fullname || c.employeename || "",
            leveldepartmentname: user?.leveldepartmentname || [],
          };
        });
      setConsolidatedContractData(merged);
    })();

    return () => {
      cancelled = true;
    };
  }, [findData, userDataList]);

  const handleRowClick = (record) => {
    if (
      selectedItem === "performance-management" &&
      record?.contractstatus === "accepted"
    ) {
      history.push(`/awaitngresponse/${record?.contractid}`, {
        appraisalRecord: record,
      });
    } else if (
      selectedItem === "performance-management" &&
      record?.contractstatus === "reviewed"
    ) {
      history.push({
        pathname: `/viewmytabledata/${record?.contractid}`,
        state: {
          appraisalRecord: record,
          isEdit: false,
          data: record,
          roletype: record.roletype,
          isMyTeam: true,
        },
      });
    } else if (
      (selectedItem === "performance-contract" &&
        (record?.contractstatus === "created" ||
          record?.contractstatus === "resend" ||
          record?.contractstatus === "updated" ||
          record?.contractstatus === "attended")) ||
      record?.contractstatus === "declined" ||
      record?.contractstatus === "accepted" ||
      record?.contractstatus === "accepted" ||
      record?.contractstatus === "reviewed"
    ) {
      history.push(`/viewcontract/${record?.contractid}`, {
        appraisalRecord: record,
      });
    }
  };

  const deleteContract = async (record) => {
    try {
      setIsDeleteModalLoading(true);
      const { code } = await CALL_API(
        `appraisal/${record?.contractid}`,
        "delete"
      );
      if (code === STATUS_CODE.SUCCESS) {
        message.success("Contract deleted successfully");
        getPerformanceContractData();
        setIsDeleteModalOpen(false);
      }
    } catch (err) {
      message.error("Failed to delete contract");
    } finally {
      setIsDeleteModalLoading(false);
    }
  };

  const handleAdjustDateClick = (e, record) => {
    e.stopPropagation();
    setAdjustDateRecord(record);
    setAdjustStartDate(record?.attendstartdate ? dayjs(record.attendstartdate) : null);
    setAdjustEndDate(record?.attendenddate ? dayjs(record.attendenddate) : null);
    setIsAdjustDateModalOpen(true);
  };

  const handleAdjustDateSubmit = async () => {
    if (!adjustStartDate || !adjustEndDate) {
      message.error("Please select both start and end dates.");
      return;
    }
    try {
      setIsAdjustDateLoading(true);
      const payload = {
        attendstartdate: adjustStartDate.format("YYYY-MM-DD"),
        attendenddate: adjustEndDate.format("YYYY-MM-DD"),
      };
      const { code } = await CALL_API(
        `appraisal/performancecontract/appraisermyteam?contractid=${adjustDateRecord?.contractid}&isAdjustAppraisal=true`,
        "patch",
        payload
      );
      if (code === STATUS_CODE?.SUCCESS) {
        message.success("Appraisal date adjusted successfully");
        setIsAdjustDateModalOpen(false);
        getPerformanceContractData();
      } else {
        message.error("Failed to adjust appraisal date.");
      }
    } catch (err) {
      message.error("Failed to adjust appraisal date.");
    } finally {
      setIsAdjustDateLoading(false);
    }
  };

  useEffect(() => {
    if (editPerformanceData) {
      form.setFieldsValue(editPerformanceData);
    }
  }, [editPerformanceData, form]);

  const getChartData = async (userId, contractid) => {
    try {
      setChartLoading(true);
      const { performanceContractList, code } = await CALL_API(
        `/appraisal/appraiseemine?userid=${userId}`,
        "get"
      );
      if (code === "SUCCESS") {
        // Show only the clicked contract's own score — not blended with
        // other roles in the same cycle.
        const clickedContract = performanceContractList?.find(
          (item) => item?.contractid === contractid
        );

        const averageTechnicalScore =
          Number(clickedContract?.averagetechnicalscore) || 0;
        const averageSoftScoreForPrimary =
          Number(clickedContract?.averagesoftscore) || 0;

        if (clickedContract?.contractstatus === "reviewed") {
          setChartData({
            xvalue: Number(averageSoftScoreForPrimary.toFixed(2)),
            yvalue: Number(averageTechnicalScore.toFixed(2)),
          });
        } else {
          setChartData({});
        }
        setChartLoading(false);
      } else {
        setChartLoading(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      return [];
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: "25%",
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "25%",
    },
    {
      title: "Type",
      dataIndex: "appraisalInformation",
      key: "appraisalInformation",
      width: "25%",
      render: (appraisalInformation, record) => {
        if (record?.roletype) {
          return record.roletype;
        }

        if (!appraisalInformation || appraisalInformation.length === 0) {
          return "-";
        }
        const types = appraisalInformation
          ?.map((info) => info?.roletype)
          ?.join(", ");
        return types || "-";
      },
    },
    {
      title: "Period",
      dataIndex: "period",
      key: "period",
      width: "25%",
      render: (text) => {
        return text ? text : "---";
      },
    },
    {
      title: "Created",
      dataIndex: "createdat",
      key: "createdat",
      width: "25%",
      render: (text) => {
        return text ? dayjs(text, "YYYY-MM-DD").format("Do MMM, YYYY") : "---";
      },
    },
    {
      title: "Attend Appraisal",
      dataIndex: "attendappraisal",
      key: "attendappraisal",
      width: "25%",
      render: (text, record) => {
        const startDate = record?.attendstartdate || null;
        const endDate = record?.attendenddate || null;

        if (startDate && endDate) {
          return `${dayjs(startDate).isValid() ? dayjs(startDate).format("Do MMM, YYYY") : "---"} - ${dayjs(endDate).isValid() ? dayjs(endDate).format("Do MMM, YYYY") : "---"
            }`;
        } else if (startDate && dayjs(startDate).isValid()) {
          return dayjs(startDate).format("Do MMM, YYYY");
        } else if (endDate && dayjs(endDate).isValid()) {
          return dayjs(endDate).format("Do MMM, YYYY");
        } else {
          return "---";
        }
      },
    },
    {
      title: "Status",
      dataIndex: "contractstatus",
      key: "contractstatus",
      width: "25%",
      render: (text, record) => {
        if (selectedItem === "performance-contract") {
          return text === "created" ||
            text === "resend" ||
            text === "updated" ? (
            "Waiting for Acceptance"
          ) : text === "accepted" ||
            text === "attended" ||
            text === "reviewed" ||
            // "draft" is the appraiser's review-in-progress draft (Save as
            // Draft on the review page) — the contract itself was accepted.
            // Creation drafts use "contractdraft", not this.
            text === "draft" ? (
            "Accepted"
          ) : text === "declined" ? (
            <p className="text-warning p-0 m-0">Declined</p>
          )
            :
            (
              <>
                <p className="text-danger p-0 m-0" style={{ display: "flex", alignItems: "center", }}>
                  Not Yet Created{text === "contractdraft" && <span style={{ background: "#ccc", borderRadius: "5px", color: 'grey' }} className="mx-2 px-2 py-1">Draft</span>}
                </p>

              </>
            );
        } else {
          const start = dayjs(record?.attendstartdate, "YYYY-MM-DD");
          const today = dayjs();
          if (text === "accepted") {
            return "Awaiting Appraisee Response";
          } else if (text === "attended" || text === "draft") {
            return (
              <>
                <span style={{ color: "red" }}>Yet to Review </span>
                {text === "draft" && (
                  <span
                    style={{ background: "#ccc", borderRadius: "5px" }}
                    className="mx-2 px-2 py-1"
                  >
                    Draft
                  </span>
                )}
              </>
            );
          } else if (text === "reviewed") {
            return "Closed";
          }
        }
      },
    },
    {
      title: "Action",
      dataIndex: "contractstatus",
      key: "contractstatus",
      width: 300,
      align: "center",
      render: (text, record) => {
        const start = dayjs(record?.attendstartdate, "YYYY-MM-DD");
        const today = dayjs();

        const handleEditClick = (e) => {
          e.stopPropagation();
          setSelectedUserRecord(record);
          setIsAddEdit(true);
          setBreadCrum(true);
        };

        const handleCreateClick = (e) => {
          e.stopPropagation();
          setSelectedUserRecord(record);
          setIsAddEdit(true);
          setBreadCrum(false);
        };

        const handleDeleteClick = (e) => {
          e.stopPropagation();
          setRecordToDelete(record);
          setIsDeleteModalOpen(true);
        };

        const deleteIconWithModal = (
          <TrashDelete
            className="table_action_icon"
            onClick={handleDeleteClick}
          />
        );

        if (selectedItem === "performance-contract") {
          if (
            record.contractstatus === "accepted" ||
            record.contractstatus === "created" ||
            record.contractstatus === "declined" ||
            record.contractstatus === "attended" ||
            record.contractstatus === "reviewed" ||
            record.contractstatus === "resend" ||
            record.contractstatus === "updated" ||
            record.contractstatus === "contractdraft" ||
            record.contractstatus === "draft"
          ) {
            console.log(record.contractstatus, "record.contractstatus")
            return (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  justifyContent: "end",
                  margin: "0px -20px",
                }}
              >
                {record.contractstatus === "accepted" && (
                  <CalendarOutlined
                    className="table_action_icon"
                    style={{ fontSize: 18, padding: 6, borderRadius: 6 }}
                    onClick={(e) => handleAdjustDateClick(e, record)}
                  />
                )}
                {
                  record.contractstatus !== "attended" &&
                  record.contractstatus !== "reviewed" &&
                  record.contractstatus !== "draft" &&
                  record.contractstatus !== "accepted" && (
                    <>
                      <EditOutlined
                        style={{
                          color: "#00685F",
                          cursor: "pointer",
                          background: "#deefee",
                          padding: "2px",
                          borderRadius: "4px",
                          height: "25px",
                          width: "25px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 18
                        }}
                        name="edit"
                        className="table_action_icon"
                        onClick={handleEditClick}
                      />
                    </>
                  )}
                {record.contractstatus !== "accepted" && record.contractstatus !== "reviewed" && record.contractstatus !== "attended" && record.contractstatus !== "draft" && (
                  <>{deleteIconWithModal}</>
                )}
              </div>
            );
          }

          return (
            <ButtonFilled onClick={handleCreateClick}>
              Create Contract
            </ButtonFilled>
          );
        } else {
          if (text === "attended" || text === "draft") {
            return (
              <div className="d-flex align-items-center justify-content-end gap-2">
                <ButtonFilled
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push({
                      pathname: `/viewmytabledata/${record?.contractid}`,
                      state: {
                        appraisalRecord: record,
                        isEdit: text === "attended" || text === "draft",
                        data: record,
                        roletype: record.roletype,
                        isMyTeam: true,
                      },
                    });
                  }}
                >
                  Review
                </ButtonFilled>
              </div>
            );
          }

          if (text === "accepted") {
            return (
              <div className="d-flex align-items-center justify-content-end gap-2">
                <CalendarOutlined
                  className="table_action_icon"
                  style={{ fontSize: 18, padding: 6, borderRadius: 6 }}
                  onClick={(e) => handleAdjustDateClick(e, record)}
                />
              </div>
            );
          }

          if (text === "reviewed") {
            return (
              <div className="d-flex align-items-center justify-content-end gap-2">
                <ChartBarIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    getChartData(record?.userid, record?.contractid);
                    setChartModalOpen(true);
                  }}
                  style={{
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    borderRadius: "25px",
                    boxShadow:
                      "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                  }}
                />
              </div>
            );
          }
        }
      },
    },
  ];

  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const { Option } = Select;

  const getContractStatusLabel = (contractstatus) => {
    if (
      contractstatus === "created" ||
      contractstatus === "resend" ||
      contractstatus === "updated"
    ) {
      return "Waiting for Acceptance";
    }
    if (
      contractstatus === "accepted" ||
      contractstatus === "attended" ||
      contractstatus === "reviewed" ||
      contractstatus === "draft"
    ) {
      return "Accepted";
    }
    if (contractstatus === "declined") {
      return "Declined";
    }
    return "Not Yet Created";
  };

  const getAppraisalStatusLabel = (item) => {
    const start = dayjs(item?.attendstartdate, "YYYY-MM-DD");
    const today = dayjs();
    if (item?.contractstatus === "accepted") {
      return "Awaiting Appraisee Response";
    }
    if (
      item?.contractstatus === "accepted" ||
      item?.contractstatus === "declined" ||
      item?.contractstatus === "attended"
    ) {
      return "Yet to Review";
    }
    if (item?.contractstatus === "reviewed") {
      return "Closed";
    }
    return "Created";
  };

  const DEFAULT_CONTRACT_STATUS_FILTERS = [
    "Not Yet Created",
    "Waiting for Acceptance",
    "Declined",
  ];
  const DEFAULT_APPRAISAL_STATUS_FILTERS = [
    "Yet to Review",
    "Awaiting Appraisee Response",
  ];

  const statusManuallyChangedRef = useRef({
    "performance-contract": false,
    "performance-management": false,
  });

  const handleFilter = (data) => {
    const type = data?.type || [];
    const performanceContractName = data?.name || [];
    const roleType = data?.roletype || [];
    const status = data?.status || [];
    const year = data?.year || [];
    const selectedDate = data?.date;

    const today = dayjs().endOf("day");
    let start = null;
    let end = null;

    // Handle date range logic
    if (selectedDate === "All") {
      setShowDateRange(false);
    } else if (selectedDate === "Last week") {
      start = dayjs().subtract(7, "days").startOf("day");
      end = today;
      setShowDateRange(false);
    } else if (selectedDate === "Last month") {
      start = dayjs().subtract(1, "months").startOf("month");
      end = dayjs().subtract(1, "months").endOf("month");
      setShowDateRange(false);
    } else if (selectedDate === "Last 6 months") {
      start = dayjs().subtract(6, "months").startOf("month");
      end = today;
      setShowDateRange(false);
    } else if (selectedDate === "custom") {
      setShowDateRange(true);
      if (fromDate && toDate) {
        start = fromDate;
        end = toDate;
      } else {
        start = null;
        end = null;
      }
    } else if (selectedDate) {
      // If manually selected specific date
      const parsed = dayjs(selectedDate, "DD-MM-YYYY");
      start = parsed.startOf("day");
      end = parsed.endOf("day");
    }

    const sourceData =
      selectedItem === "performance-contract"
        ? findData
        : filterPerformanceData;

    return sourceData.filter((item) => {
      const typeMatch = type.length > 0 ? type.includes(item?.period) : true;
      const roleTypeMatch =
        roleType.length > 0
          ? roleType.includes(item?.appraisalInformation?.[0]?.roletype)
          : true;
      const statusMatch =
        status.length > 0
          ? status.includes(
            selectedItem === "performance-contract"
              ? getContractStatusLabel(item?.contractstatus)
              : getAppraisalStatusLabel(item)
          )
          : true;
      const nameMatch =
        performanceContractName.length > 0
          ? performanceContractName.includes(item?.userid)
          : true;

      // Parse item attend dates

      // Apply actual filtering logic here
      const dateMatch =
        start && end
          ? dayjs(item?.attendstartdate)?.isSameOrBefore(end, "day") &&
          dayjs(item?.attendenddate)?.isSameOrAfter(start, "day")
          : true;

      // Year filter — same overlap logic as the Date filter above, just with
      // the range fixed to the calendar year. Multi-select, so a contract
      // matches if its appraisal period overlaps ANY of the selected years.
      const yearMatch =
        year.length > 0
          ? year.some((y) => {
            const { start: fyStart, end: fyEnd } = getFinancialYearRange(y);
            return (
              dayjs(item?.attendstartdate)?.isSameOrBefore(fyEnd, "day") &&
              dayjs(item?.attendenddate)?.isSameOrAfter(fyStart, "day")
            );
          })
          : true;

      return (
        typeMatch && roleTypeMatch && statusMatch && nameMatch && dateMatch && yearMatch
      );
    });
  };

  // Years present in the current tab's data, newest first. Derived rather than
  // hardcoded so the list always matches what's actually there — a contract's
  // appraisal period can straddle a year boundary, so both ends contribute.
  const yearOptions = useMemo(() => {
    const source =
      selectedItem === "performance-contract" ? findData : filterPerformanceData;
    const years = new Set();
    (source || []).forEach((item) => {
      [item?.attendstartdate, item?.attendenddate].forEach((d) => {
        const fy = getFinancialYear(d);
        if (fy) years.add(fy);
      });
    });
    return Array.from(years)
      .sort((a, b) => b.localeCompare(a))
      .map((fy) => ({ label: fy, value: fy }));
  }, [selectedItem, findData, filterPerformanceData]);

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    const values = form.getFieldsValue();
    setFilteredData(handleFilter(values));
  };

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    setFilteredData(handleFilter(values));
  };

  useEffect(() => {
    if (statusManuallyChangedRef.current[selectedItem]) return;

    const source =
      selectedItem === "performance-contract" ? findData : filterPerformanceData;
    const safeSource = source || [];

    const defaultStatusValues =
      selectedItem === "performance-contract"
        ? DEFAULT_CONTRACT_STATUS_FILTERS
        : DEFAULT_APPRAISAL_STATUS_FILTERS;

    const availableStatusLabels = new Set(
      safeSource.map((item) =>
        selectedItem === "performance-contract"
          ? getContractStatusLabel(item?.contractstatus)
          : getAppraisalStatusLabel(item)
      )
    );
    const applicableDefaults = defaultStatusValues.filter((label) =>
      availableStatusLabels.has(label)
    );

    const currentStatus = form.getFieldValue("status") || [];
    const alreadyInSync =
      currentStatus.length === applicableDefaults.length &&
      applicableDefaults.every((label) => currentStatus.includes(label));

    if (alreadyInSync) return;

    form.setFieldsValue({ status: applicableDefaults });
    handleFormChange();
  }, [selectedItem, findData, filterPerformanceData]);

  useEffect(() => {
    handleFormChange();
  }, [selectedItem, findData, filterPerformanceData, fromDate, toDate, loadNewDataList]);

  const content = (
    <span>
      This will generate a new list of appraisees whose<br></br> previous
      appraisals have been closed, allowing<br></br> you to create fresh
      performance contracts for<br></br> them by retaining their previous
      contracts
    </span>
  );

  // auto-syncing once they've made their own choice.
  const handleStatusFilterChange = () => {
    statusManuallyChangedRef.current[selectedItem] = true;
    handleFormChange();
  };

  return (
    <Styleddiv>
      <Modal
        title="Confirm Deletion"
        open={isDeleteModalOpen}
        onOk={() => deleteContract(recordToDelete)}
        onCancel={() => setIsDeleteModalOpen(false)}
        okText="Yes"
        cancelText="No"
        confirmLoading={isDeleteModalLoading}
      >
        <p>Are you sure you want to delete this contract?</p>
      </Modal>

      <StyledModal
        title="Adjust Appraisal Date"
        open={isAdjustDateModalOpen}
        onCancel={() => setIsAdjustDateModalOpen(false)}
        footer={null}
        width={480}
      >
        <div style={{ marginTop: 8 }}>
          <p style={{ marginBottom: 6, color: "#636980" }}>Start date to attend appraisal</p>
          <DatePicker
            style={{ width: "100%", borderRadius: 24 }}
            format="Do MMM YYYY"
            value={adjustStartDate}
            onChange={(date) => setAdjustStartDate(date)}
          />

          <p style={{ marginTop: 16, marginBottom: 6, color: "#636980" }}>End Date to attend appraisal</p>
          <DatePicker
            style={{ width: "100%", borderRadius: 24 }}
            format="Do MMM YYYY"
            value={adjustEndDate}
            onChange={(date) => setAdjustEndDate(date)}
          />

          <div className="two-buttons">
            <Button className="no-modal-button" onClick={() => setIsAdjustDateModalOpen(false)}>
              Cancel
            </Button>
            <Button
              className="yes-modal-button"
              loading={isAdjustDateLoading}
              onClick={handleAdjustDateSubmit}
            >
              Adjust Date
            </Button>
          </div>
        </div>
      </StyledModal>

      <Modal
        open={isBlockedModalOpen}
        footer={null}
        closable={false}
        centered
        width={560}
        onCancel={() => setIsBlockedModalOpen(false)}
      >
        <div style={{ textAlign: "center", padding: "8px 4px" }}>
          <ExclamationCircleFilled
            style={{
              fontSize: 40,
              color: "#fff",
              background: "#e63946",
              borderRadius: "50%",
              padding: 8,
            }}
          />
          <div style={{ textAlign: "left", marginTop: 20 }}>
            <p style={{ fontSize: 15, color: "#333", marginBottom: 4 }}>
              List Generated: {loadListSummary.generated}
            </p>
            <p style={{ fontSize: 15, color: "#333", marginBottom: 16 }}>
              List not generated: {loadListSummary.notGenerated}
            </p>
            <p style={{ fontSize: 15, color: "#333" }}>
              The employees listed below have pending appraisals from the
              previous cycle. New contracts cannot be generated until
              appraisals of every role have been closed.
            </p>
          </div>
          <Table
            dataSource={blockedUsers}
            rowKey={(r) => r.user.userid}
            columns={blockedColumns}
            pagination={false}
            size="small"
            style={{ marginTop: 16, textAlign: "left" }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
            <Button
              onClick={() => setIsBlockedModalOpen(false)}
              style={{
                minWidth: 110,
                background: "#8FE3C5",
                borderColor: "#8FE3C5",
                color: "#0B3B2E",
              }}
            >
              Got it
            </Button>
          </div>
        </div>
      </Modal>

      {!isAddEdit && (
        <>
          <div>
            <Row>
              <Col sm={24}>
                <Form
                  form={form}
                  layout="vertical"
                  className="mt-2"
                  onValuesChange={handleFormChange}
                >
                  <Row gutter={12} className="g-3 mb-2">
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="name"
                        label="Search"
                        options={uniqBy(
                          (selectedItem === "performance-contract"
                            ? findData
                            : filteredData
                          ).map((val) => ({
                            label: val.fullname,
                            value: val.userid,
                          })),
                          "value"
                        )}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="type"
                        label="Period"
                        options={[
                          {
                            value: "Half Yearly Appraisal",
                            label: "Half Yearly",
                          },
                          { value: "Quarterly Appraisal", label: "Quarterly" },
                          { value: "Yearly Appraisal", label: "Yearly" },
                        ]}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <Form.Item
                        name="date"
                        label=""
                        className="search-type-date"
                      >
                        <Select
                          placeholder="Date"
                          value={selectedDateRange}
                          onChange={handleSelectChange}
                          className="custom-select"
                        >
                          <Option value="All">All</Option>
                          <Option value="Last week">Last Week</Option>
                          <Option value="Last month">Last Month</Option>
                          <Option value="Last 6 months">Last 6 Months</Option>
                          <Option value="custom">Custom</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    {showDateRange && (
                      <Form.Item>
                        <StyledRangePicker
                          format="DD-MM-YYYY"
                          onChange={(dates) => {
                            setFromDate(dates ? dates[0] : null);
                            setToDate(dates ? dates[1] : null);
                          }}
                        />
                      </Form.Item>
                    )}
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="roletype"
                        label="RoleType"
                        options={uniqBy(
                          (selectedItem === "performance-contract"
                            ? findData
                            : filterPerformanceData
                          )?.map((val) => {
                            return {
                              value: val?.appraisalInformation?.[0]?.roletype,
                              label: val?.appraisalInformation?.[0]?.roletype,
                            };
                          }),
                          "value"
                        )}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="status"
                        label="Status"
                        options={
                          selectedItem === "performance-contract"
                            ? uniqBy(
                              findData?.map((val) => {
                                const label = getContractStatusLabel(
                                  val?.contractstatus
                                );
                                return { value: label, label };
                              }),
                              "value"
                            )
                            : uniqBy(
                              filterPerformanceData?.map((val) => {
                                const label = getAppraisalStatusLabel(val);
                                return { value: label, label };
                              }),
                              "value"
                            )
                        }
                        // options={[
                        //   {
                        //     value: "Half Yearly",
                        //     label: "Awaiting Appraisal Response",
                        //   },
                        //   { value: "Quarterly", label: "Yet to Review" },
                        //   { value: "Yearly", label: "Closed" },
                        // ]}
                        form={form}
                        handleFormChange={handleStatusFilterChange}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="year"
                        label="Year"
                        options={yearOptions}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            <br />
            <div className="w-100 d-flex justify-content-between align-items-center">
              <b>List of Contract: {filteredData?.length || 0}</b>
              {selectedItem === "performance-contract" && (
                <Popover placement="topLeft" content={content}>
                  <ButtonFilled
                    loading={newDataLoading}
                    onClick={getLoadNewList}
                  >
                    Load New List
                  </ButtonFilled>
                </Popover>
              )}
              {selectedItem === "performance-management" && (
                <ButtonFilled
                  // loading={newDataLoading}
                  onClick={() => setIsConsolidate(true)}
                >
                  Consolidated
                </ButtonFilled>
              )}
            </div>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              rowKey={(record) =>
                record.contractid
                  ? String(record.contractid)
                  : `stub-${record.userid}`
              }
              rowClassName={() => "custom-row"}
              onRow={(record) => ({
                onClick: () => handleRowClick(record),
                onMouseEnter: () => setHoveredRow(record.contractid),
                onMouseLeave: () => setHoveredRow(null),
                style: { cursor: "pointer" },
              })}
            />
          </div>
        </>
      )}
      <Modal
        centered
        width={1000}
        style={{ borderRadius: "8px", overflow: "hidden" }}
        footer={null}
        title="Overall Performance Matrix"
        visible={chartModalOpen}
        onCancel={() => {
          setChartModalOpen(false);
          setChartData({});
        }}
      >
        <>
          <Spin spinning={chartLoading}>
            {chartData?.xvalue !== undefined &&
              chartData?.yvalue !== undefined ? (
              <PerformanceMatrix
                Xaxis={chartData?.xvalue}
                Yaxis={chartData?.yvalue}
              />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 300,
                  }}
                >
                  <FolderIcon
                    style={{ width: 200, height: 200, marginBottom: 10 }}
                  />{" "}
                  <p
                    style={{ fontSize: 18, color: "#999", textAlign: "center" }}
                  >
                    {" "}
                    The Appraiser(s) haven't Reviewed the appraisal yet
                  </p>
                </div>
              </>
            )}
          </Spin>
        </>
      </Modal>
      <Modal
        centered
        width={1000}
        style={{ borderRadius: "8px", overflow: "auto" }}
        footer={null}
        title="Consolidated Performance Matrix of Appraisees"
        visible={isConsolidate}
        onCancel={() => {
          setIsConsolidate(false);
        }}
      >
        <Consolidated
          contractData={consolidatedContractData}
          userDataList={userDataList}
          userInfo={userInfo}
        />
      </Modal>
    </Styleddiv>
  );
};
const mapStateToProps = (state) => ({
  supervisorList: getSupervisorList(state),
  userInfo: getUserInfo(state),
  loadNewDataList: getLoadNewDataList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLoadNewData: setLoadNewDataList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(MyTeamPerformance);